module.exports = __webpack_public_path__ + "static/media/hamburger_grey_icon.a4b96780.svg";